import { useTranslation } from 'react-i18next';
import { useSelectedCompany } from '@fingo/lib/hooks';
import {
  getSiiCredentials,
  getInvoiceProviderCredentials,
  getDigitalCertificateCredentials,
  getBankAccountCredentials,
} from '../helpers/credentials';

const useCompanyCredentials = () => {
  const selectedCompany = useSelectedCompany();
  const { t } = useTranslation();

  const nationalTaxService = t('National Tax Service acronym');

  if (!selectedCompany) return [];

  return [
    getSiiCredentials(selectedCompany, nationalTaxService),
    getInvoiceProviderCredentials(selectedCompany),
    getDigitalCertificateCredentials(selectedCompany),
    getBankAccountCredentials(selectedCompany),
  ];
};

export default useCompanyCredentials;
